// import React from "react";

// const Input = React.forwardRef(({ label, error, icon, ...rest }, ref) => {
//   return (
//     <div className="mb-3">
//       {label && <label className="form-label">{label}</label>}
//       <div className="input-group">
//         {icon && (
//           <span className="input-group-text">
//             <i className="material-icons">{icon}</i>
//           </span>
//         )}
//         <input ref={ref} {...rest} className="form-control" />
//       </div>
//       {error && <small className="text-danger">{error}</small>}
//     </div>
//   );
// });

// export default Input;

import React, { useState } from "react";

const Input = React.forwardRef(({ label, error, icon, ...rest }, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="mb-4">
      {label && (
        <label
          className="form-label fw-medium mb-2"
          style={{
            color: "#2d3748",
            fontSize: "0.9rem",
            letterSpacing: "0.01em",
          }}
        >
          {label}
        </label>
      )}

      <div
        className="input-group position-relative"
        style={{
          transition: "all 0.3s ease",
        }}
      >
        {icon && (
          <span
            className="input-group-text border-0 d-flex align-items-center justify-content-center"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              borderRadius: "10px 0 0 10px",
              width: "46px",
              transition: "all 0.3s ease",
              boxShadow: isFocused
                ? "0 0 0 3px rgba(102, 126, 234, 0.1)"
                : "none",
            }}
          >
            <i className="material-icons" style={{ fontSize: "20px" }}>
              {icon}
            </i>
          </span>
        )}

        <input
          ref={ref}
          {...rest}
          className="form-control border-0 shadow-sm"
          style={{
            padding: "0.75rem 1rem",
            borderRadius: icon ? "0 10px 10px 0" : "10px",
            fontSize: "0.95rem",
            transition: "all 0.3s ease",
            backgroundColor: "#f8f9fa",
            boxShadow: isFocused
              ? "0 0 0 3px rgba(102, 126, 234, 0.1), 0 4px 12px rgba(0,0,0,0.08)"
              : "0 2px 6px rgba(0,0,0,0.04)",
            outline: "none",
          }}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />

        {/* Animated border effect */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2px",
            background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
            transform: isFocused ? "scaleX(1)" : "scaleX(0)",
            transition: "transform 0.3s ease",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </div>

      {error && (
        <small
          className="text-danger d-flex align-items-center mt-2"
          style={{
            fontSize: "0.85rem",
            fontWeight: "500",
            animation: "slideDown 0.3s ease",
          }}
        >
          <i className="material-icons me-1" style={{ fontSize: "16px" }}>
            error
          </i>
          {error}
        </small>
      )}

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        input::placeholder {
          color: #a0aec0;
          font-weight: 400;
        }
        
        input:hover {
          background-color: #ffffff !important;
        }
      `}</style>
    </div>
  );
});

export default Input;
